import { Button } from "@mui/material";
import { styled } from "@mui/material";

const StyleButton = styled(Button)`
  display: flex;
  background-color: var(--bkg-primary);
  color: var(--text-primary);
  border-radius: 5px !important;
  padding: 8px;
  font-size: 16px;
  text-transform: none;
  font-weight: 500;
  height: 45px !important;
  width: fit-content;
  &:hover {
    background-color: var(--bkg-primary);
    cursor: pointer;
  }
`;

const StleButtonActive = {
  color: "var(--main-color)",
  backgroundColor: "var(--bkg-primary)",
};

export const FilterButton = ({ children, style, isActive, ...props }) => {
  return (
    <StyleButton sx={isActive ? StleButtonActive : {}} {...props}>
      {children}
    </StyleButton>
  );
};
